import { useCallback, useEffect, useState } from "react";
import { trackEvent } from "services/bigbrain-service";
import { HOVERABLE_CARD_HOVERED } from "constants/bigbrain-event-types";
import HoverableCard from "./hoverable-card/hoverable-card";
import { StyledHoverableCardsGridComponent } from "./hoverable-cards-grid-component.scss";

const HoverableCardsGridComponent = ({ cards, defaultHoveredCard, defaultColor, fullParagraphAdvancedConfig, textResizeConfig }) => {
  const [contentMaxHeight, setContentMaxHeight] = useState(null);
  const [selectedCardIndex, setSelectedCardIndex] = useState(
    defaultHoveredCard - 1 < cards.length ? defaultHoveredCard - 1 : 0
  );

  const setCardMaxHeight = useCallback((height) => {
    setContentMaxHeight((maxHeight) => Math.max(height, maxHeight ?? 0));
  }, []);

  const restartMaxHeight = useCallback(() => setContentMaxHeight(null), []);

  const onCardHover = (index) => {
    setSelectedCardIndex(index);
    trackEvent(HOVERABLE_CARD_HOVERED, { info1: index });
  };

  useEffect(() => {
    window.addEventListener("resize", restartMaxHeight);
    return () => window.removeEventListener("resize", restartMaxHeight);
  }, [restartMaxHeight]);

  return (
    <StyledHoverableCardsGridComponent
      className="hoverable-cards-grid-component"
      style={{ height: `${contentMaxHeight}px` }}
    >
      {cards?.map((card, index) => (
        <HoverableCard
          textResizeConfig={textResizeConfig}
          setCardsMaxHeight={setCardMaxHeight}
          fullParagraphAdvancedConfig={fullParagraphAdvancedConfig}
          defaultColor={defaultColor}
          isSelected={index === selectedCardIndex}
          onHover={() => onCardHover(index)}
          key={index}
          {...card}
        />
      ))}
    </StyledHoverableCardsGridComponent>
  );
};

export default HoverableCardsGridComponent;
